import { useRef } from 'react';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { FaWhatsapp, FaFacebook, FaTwitter, FaLinkedin, FaEnvelope, FaTimes } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const ContractDocument = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [pdfDownloaded, setPdfDownloaded] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [showSharePopup, setShowSharePopup] = useState(false);
  const [editableFields, setEditableFields] = useState({
    aggregatorName: "African Marmalade",
    aggregatorDate: "2025/06/07",
    farmerName: "Tsepo Dhlamini",
    farmerDate: "2025/06/07"
  });
  const pdfRef = useRef();

  const displayData = location.state || {};
  const { formData = {} } = displayData;
  const safeFormData = {
    firstName: '',
    surname: '',
    mobile: '',
    email: '',
    physicalAddress: '',
    idNumber: '',
    ...formData
  };

  const handleFieldChange = (field, value) => {
    setEditableFields(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleShare = async (platform) => {
    if (!pdfDownloaded) {
      alert('Please download the PDF first before sharing');
      return;
    }
    
    const pdfUrl = `Contract_${safeFormData.firstName || 'Document'}.pdf`;
    const shareText = `Please check out my contract document: ${pdfUrl}`;
    
    switch(platform) {
      case 'whatsapp':
        window.open(`https://wa.me/?text=${encodeURIComponent(shareText)}`, '_blank');
        break;
      case 'facebook':
        window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(pdfUrl)}`, '_blank');
        break;
      case 'twitter':
        window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}`, '_blank');
        break;
      case 'linkedin':
        window.open(`https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(pdfUrl)}&title=${encodeURIComponent('Contract Document')}&summary=${encodeURIComponent(shareText)}`, '_blank');
        break;
      case 'email':
        window.open(`mailto:?subject=Contract Document&body=${encodeURIComponent(shareText)}`);
        break;
      default:
        break;
    }
  };

  const handleDownloadPDF = async () => {
    if (!pdfRef.current) {
      console.error('No content to print');
      return;
    }
  
    setIsDownloading(true);
    setPdfDownloaded(false);
    
    try {
      const element = pdfRef.current;
      
      // Store original styles to restore later
      const originalStyles = {
        overflow: element.style.overflow,
        height: element.style.height,
        width: element.style.width,
      };
      
      // Make element full size for capture
      element.style.overflow = 'visible';
      element.style.height = 'auto';
      element.style.width = '100%';
  
      // Hide elements that shouldn't be printed
      const noPrintElements = document.querySelectorAll('.no-print');
      noPrintElements.forEach(el => {
        el.style.visibility = 'hidden';
      });
  
      // Generate canvas with html2canvas
      const canvas = await html2canvas(element, {
        scale: 1,
        useCORS: true,
        logging: false,
        backgroundColor: '#FFFFFF',
        scrollY: -window.scrollY,
        windowHeight: element.scrollHeight,
        ignoreElements: (el) => el.style.visibility === 'hidden'
      });
  
      // Clean up
      noPrintElements.forEach(el => {
        el.style.visibility = '';
      });
      Object.assign(element.style, originalStyles);
  
      // Create PDF with full content height
      const pdf = new jsPDF({
        orientation: 'p',
        unit: 'mm',
        format: [canvas.width * 0.264583, canvas.height * 0.264583]
      });
  
      // Add image to PDF
      pdf.addImage(
        canvas.toDataURL('image/jpeg', 0.85),
        'JPEG',
        0,
        0,
        pdf.internal.pageSize.getWidth(),
        pdf.internal.pageSize.getHeight()
      );
  
      // Save the PDF7
      pdf.save(`Contract_${safeFormData.firstName || 'Document'}.pdf`);
      setPdfDownloaded(true);
      
      // Navigate to Contract3 page after successful download
      navigate('/contract4', { state: { formData: safeFormData } });
      
    } catch (error) {
      console.error('PDF generation error:', error);
      alert(`Failed to generate PDF: ${error.message}`);
      setPdfDownloaded(false);
    } finally {
      setIsDownloading(false);
    }
  };

  const renderButtonWithIcon = (text, bgColor, iconColor, isLarge = false) => {
    const bgColorClasses = {
      "#152C24": "bg-[#152C24]",
      "#2E453D": "bg-[#2E453D]",
      "#FDBB26": "bg-[#FDBB26]",
    };

    const iconColorClasses = {
      "#152C24": "bg-[#152C24]",
      "#2E453D": "bg-[#2E453D]",
      "#FDBB26": "bg-[#FDBB26]",
    };

    return (
      <div className="flex items-center">
        <div className={`${bgColorClasses[bgColor]} text-white md:text-[16px] text-[5px] px-2 md:px-4 ${
          isLarge ? "md:py-[14px] py-[3px]" : "md:py-[14px] py-[3px]"
        } md:rounded-l-md rounded-l-md font-bold md:w-[300px] whitespace-nowrap flex items-center h-full`}>
          {text}
        </div>
        
        <div className={`${iconColorClasses[iconColor]} hidden md:flex items-center md:py-2 justify-center md:w-[57px] md:h-[52px] rounded-r-md`}>
          <img
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1752425373/Expand_down_light_wlhaow.png"
            alt="Expand"
            className="w-[20px] h-[6px] md:h-[40px] md:w-[55px] object-contain"
          />
        </div>
        
        <div className={`${iconColorClasses[iconColor]} md:hidden flex items-center justify-center w-[20px] h-[14px] rounded-r-md`}>
          <img
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1752425373/Expand_down_light_wlhaow.png"
            alt="Expand"
            className="w-[20px] h-[6px] object-contain"
          />
        </div>
      </div>
    );
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'Not provided';
    
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return 'Invalid date';
      
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      });
    } catch (e) {
      console.error('Date formatting error:', e);
      return 'Invalid date';
    }
  };

  return (
    <div className="bg-gray-100 p-4 md:p-8">
      <div className="max-w-7xl mx-auto bg-white p-2 md:p-8 rounded-lg shadow-lg">
        <div 
          ref={pdfRef} 
          className="w-full bg-[#F3F5F5] mx-auto border border-gray-200 print-container"
          style={{
            overflow: 'visible',
            height: 'auto',
            width: '100%',
            padding: 0,
            margin: 0
          }}
        >
          <div className='p-4 md:p-10 print:p-2'>
            <div className="flex items-center justify-between md:pb-8 pb-4">
              <h2 className="text-[14px] md:text-[36px] font-bold text-[#000]">CONTRACT</h2>
              <div className="no-print">
              <button onClick={handleDownloadPDF}>
  {renderButtonWithIcon("Share Contract", "#2E453D", "#152C24", true)}
</button>
                <p className="text-[8px] md:text-[14px] font-normal mt-1 text-black">
                  Click to share contract
                </p>
              </div>
            </div>

            <div className="flex md:flex-row justify-between gap-2 items-center mb-6 md:mb-8 md:mt-5 print:mb-4">
              <div className="w-full mb-4 md:mb-0 md:-mt-4">
                <div className='bg-white w-full md:px-2 pb-1 border-b-[2px] border-[#979797]'>
                  <h2 className="text-[12px] md:text-[32px] font-bold print:text-[20px]">
                    {safeFormData.firstName || 'First Name'} {safeFormData.surname || 'Surname'}
                  </h2>
                  <p className="text-[6px] md:text-[24px] md:mt-[11px] font-semibold print:text-[14px]">
                    <span className='text-[#979797]'>ID No:</span> {safeFormData.idNumber || 'Not provided'}
                  </p>
                </div>
                <div className='flex justify-between'>
                  <div>
                    <p className="text-[6px] md:text-[20px] text-[#152C24] font-semibold md:mt-2 print:text-[12px]">Mobile: {safeFormData.mobile || 'Not provided'}</p>
                    <p className="text-[6px] md:text-[20px] text-[#152C24] font-semibold print:text-[12px]">Email: {safeFormData.email || 'Not provided'}</p>
                    <p className="text-[6px] md:text-[20px] text-[#152C24] font-semibold print:text-[12px]">Location: {safeFormData.physicalAddress || 'Not provided'}</p>
                    <p className="text-[6px] md:text-[20px] text-[#152C24] font-semibold print:text-[12px]">Date: {formatDate(new Date().toISOString())}</p>
                  </div>
                  <div className="print:text-[10px]">
                    <p className="text-[6px] md:text-[18px] text-[#979797] tracking-wider leading-snug md:leading-[1.80] font-light text-left md:max-w-[400px] mt-2 md:mt-6 print:text-[10px] print:mt-2">
                      To ensure this registration is authentic, scan the QR Code and verify against original information and report
                    </p>
                  </div>
                </div>
              </div>
              <div className="flex flex-col-reverse md:flex-row items-end gap-2 print:flex-col">
                <img 
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1751138385/WhatsApp_Image_2025-06-28_at_10.55.30_PM_kprooh.jpg" 
                  alt="QR Code" 
                  className="w-16 h-16 md:w-[250px] md:h-[200px] mb-2 print:w-[100px] print:h-[100px]"
                />
              </div>
            </div>

            <div className="font-sans md:text-[32px] text-[10px] leading-[1.6] text-black space-y-4 md:space-y-8 py-4 md:py-2">
            <div className="font-sans md:text-[32px] text-[10px] leading-[1.6] text-black space-y-4 md:space-y-8 py-4 md:py-2">
    <p className="md:mt-6 mt-2">
      This Offtake Partnership Agreement ("Agreement") is made and entered into on this ___ day of ____________, 2025, by and between:
    </p>
    
    <p className="md:mt-6 mt-2">
      African Marmalade (Pty) Ltd, a company incorporated under the laws of South Africa, with its principal place of business at [Insert Address] (hereinafter referred to as the "Aggregator" or "African Marmalade"),
    </p>
    
    <p className="md:mt-6 mt-2">
      AND
    </p>
    
    <p className="md:mt-6 mt-2">
      The collective of member farmers affiliated with African Marmalade, represented jointly through African Marmalade and operating primarily in [Insert Region/Province], South Africa (hereinafter referred to as the "Farmers").
    </p>
    
    <p className="md:mt-6 mt-2">
      Each a "Party" and collectively referred to as the "Parties."
    </p>
    
    <div className="mt-8">
      <h3 className="font-bold">1. Purpose</h3>
      <p className="">
        This Agreement establishes a framework under which African Marmalade, as the appointed aggregator, will coordinate the supply of fresh agricultural produce from its member farmers to Bidvest Catering, a foodservice buyer. The goal is to ensure a consistent, high-quality, and traceable supply chain that benefits both the Farmers and Bidvest Catering.
      </p>
    </div>
    
    <div className="mt-8">
      <h3 className="font-bold">2. Scope of Partnership</h3>
      <p className="">2.1 The Farmers, through African Marmalade, agree to cultivate and supply seasonal fresh produce, including but not limited to [insert types: e.g., leafy greens, root vegetables, tomatoes, herbs], as per schedules agreed with Bidvest Catering.</p>
      <p className="md:mt-6 mt-2">2.2 African Marmalade shall manage aggregation, quality assurance, logistics, and delivery of the produce to Bidvest Catering in accordance with the buyer's requirements.</p>
      <p className="md:mt-6 mt-2">2.3 All produce supplied shall meet the minimum quality, safety, and grading standards as defined in Schedule A.</p>
    </div>
    
    <div className="mt-8">
      <h3 className="font-bold">3. Contractual Relationship with Bidvest Catering</h3>
      <p className="">3.1 African Marmalade shall act as the contracted supplier to Bidvest Catering, entering into a direct offtake agreement on behalf of its member farmers.</p>
      <p className="md:mt-6 mt-2">3.2 Member farmers agree that all produce destined for Bidvest Catering under this arrangement shall be coordinated and delivered exclusively through African Marmalade.</p>
      <p className="md:mt-6 mt-2">3.3 Farmers authorize African Marmalade to:</p>
      <ul className="space-y-4 md:mt-6 mt-2">
        <li>Aggregate volumes</li>
        <li>Negotiate pricing</li>
        <li>Manage payments</li>
        <li>Represent them in matters relating to the Bidvest contract</li>
      </ul>
    </div>
    
    <div className="mt-8">
      <h3 className="font-bold">4. Purchase Commitment</h3>
      <p className="">4.1 African Marmalade (through its contract with Bidvest Catering) commits to purchasing agreed-upon volumes from the Farmers per harvest season.</p>
      <p className="md:mt-6 mt-2">4.2 Pricing shall be established in Schedule B, either as a fixed farmgate price or as a minimum guaranteed price plus a market-based bonus, where applicable.</p>
      <p className="md:mt-6 mt-2">4.3 Payments to farmers shall be made by African Marmalade within [Insert number] days of confirmed delivery, via [e.g., EFT or mobile money].</p>
    </div>
    
    <div className="mt-8">
      <h3 className="font-bold">5. Obligations of the Farmers</h3>
      <p className="">The Farmers agree to:</p>
      <ul className="space-y-4 md:mt-6 mt-2">
        <li>Produce crops in accordance with agreed production plans and schedules</li>
        <li>Adhere to food safety and quality standards</li>
        <li>Participate in any training or audits coordinated by African Marmalade</li>
        <li>Notify African Marmalade of any production delays or risks</li>
      </ul>
    </div>
    
    <div className="mt-8">
      <h3 className="font-bold">6. Obligations of African Marmalade</h3>
      <p className="">African Marmalade agrees to:</p>
      <ul className="space-y-4 md:mt-6 mt-2">
        <li>Serve as the exclusive aggregator and distributor of member farmers' produce to Bidvest Catering</li>
        <li>Provide logistical coordination, collection, and quality checks</li>
        <li>Disburse payments promptly and transparently</li>
        <li>Offer technical assistance or link farmers to support programs when feasible</li>
      </ul>
    </div>
    
    <div className="mt-8">
      <h3 className="font-bold">7. Term and Termination</h3>
      <p className="">7.1 This Agreement shall remain in effect for a period of one (1) year from the Effective Date, unless renewed by mutual consent or terminated earlier.</p>
      <p className="md:mt-6 mt-2">7.2 Either Party may terminate this Agreement with 30 days' written notice, or immediately in the event of material breach.</p>
    </div>
    
    <div className="mt-8">
      <h3 className="font-bold">8. Force Majeure</h3>
      <p className="">Neither Party shall be liable for non-performance due to circumstances beyond their control, including but not limited to natural disasters, strikes, pandemics, or regulatory restrictions.</p>
    </div>
    
    <div className="mt-8">
      <h3 className="font-bold">9. Dispute Resolution</h3>
      <p className="">Disputes shall first be resolved through good-faith negotiations. If unresolved within 30 days, the dispute shall be referred to mediation or arbitration in accordance with the laws of South Africa.</p>
    </div>
    
    <div className="mt-8">
      <h3 className="font-bold">10. Governing Law</h3>
      <p className="">This Agreement shall be governed by the laws of the Republic of South Africa.</p>
    </div>
    
    <div className="mt-8">
      <h3 className="font-bold">11. Miscellaneous</h3>
      <ul className="space-y-8 md:mt-6 mt-2">
        <li>This Agreement constitutes the full understanding between the Parties.</li>
        <li>Amendments must be made in writing and signed by both Parties.</li>
        <li>Schedules A (Pricing Structure) and B (Quality Standards) form an integral part of this Agreement.</li>
      </ul>
    </div>
    
    <div className="mt-8">
   
      <p >
     <span className='font-bold'> IN WITNESS WHEREOF, </span>The Parties hereto have executed this Offtake Partnership Agreement as of the date first above written.
      </p>
    </div>
  </div>
              {/* Add the signature section before disclaimer */}
              <div className="mt-12">
  <div className="mb-2">
    <p className="font-bold md:text-[36px] text-[14px]">Signed for and on behalf of Aggregator:</p>
    <div className="flex items-baseline">
      <span className="mr-2">Name: </span>
      <div 
        className="font-bold flex-grow" 
        contentEditable 
        onBlur={(e) => handleFieldChange('aggregatorName', e.target.textContent)}
      >
        {editableFields.aggregatorName}
      </div>
    </div>
    <div className="flex items-baseline mt-2">
      <span className="mr-2">Date: </span>
      <div 
        className="font-bold  flex-grow" 
        contentEditable 
        onBlur={(e) => handleFieldChange('aggregatorDate', e.target.textContent)}
      >
        {editableFields.aggregatorDate}
      </div>
    </div>
  </div>

  <div className="mb-8">
    <p className="font-bold md:text-[36px] text-[14px]">Signed for and on behalf of Farmers:</p>
    <div className="flex items-baseline">
      <span className="mr-2">Name: </span>
      <div 
        className="font-bold  flex-grow" 
        contentEditable 
        onBlur={(e) => handleFieldChange('farmerName', e.target.textContent)}
      >
        {editableFields.farmerName}
      </div>
    </div>
    <div className="flex items-baseline mt-12">
      <span className="mr-2 font-bold">Date: </span>
      <div 
        className="font-bold  flex-grow" 
        contentEditable 
        onBlur={(e) => handleFieldChange('farmerDate', e.target.textContent)}
      >
        {editableFields.farmerDate}
      </div>
    </div>
  </div>
</div>

              {/* Disclaimer */}
              <div className="mt-6 md:mt-5 pt-2 md:pt-4">
                <p className="text-[6px] md:text-[24px] leading-[1.20]">
                  <span className='text-black font-bold '>Disclaimer: </span>Users are advised to verify all entries independently and consult with their financial or legal advisors before making any decisions based on the information provided. Farmnet shall not be held liable for any loss or damage arising directly or indirectly from the use of or reliance on this statement.
                </p>
              </div>
              
              <a href='/' className='flex justify-end text-[8px] md:text-[24px] mt-3 md:mt-1'>
                Terms & Conditions apply
              </a>
              
              {/* Closing Banner */}
              <div className="bg-[#2E453D] flex md:flex-row items-center justify-between px-2 md:px-4 mt-3 md:mt-1 shadow-black/40 shadow-md h-auto md:h-[110px] py-2 md:py-0">
                <div className="flex items-center">
                  <img
                    src="https://res.cloudinary.com/dzngpgki4/image/upload/v1748543265/FarmNet_Logo_Green_3_e3louy.png"
                    alt="Ad-Luck Holdings Logo"
                    className="w-20 md:w-[280px] h-4 md:h-[50px] object-contain"
                  />
                  <span className="text-white font-bold text-[8px] md:text-[24px] font-poppins ml-2 md:ml-4">
                    +254702157000
                  </span>
                </div>
                <div>
                  <span className="text-white font-bold text-[8px] md:text-[24px] font-poppins">
                    |    www.farmnet.africa
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {showSharePopup && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-bold">Share Contract</h3>
              <button 
                onClick={() => setShowSharePopup(false)}
                className="text-gray-500 hover:text-gray-700"
              >
                <FaTimes />
              </button>
            </div>
            
            {!pdfDownloaded ? (
              <div className="text-center py-4">
                <p className="mb-4">Preparing PDF for sharing...</p>
                <button 
                  onClick={handleDownloadPDF}
                  className="bg-[#2E453D] text-white px-4 py-2 rounded"
                  disabled={isDownloading}
                >
                  {isDownloading ? 'Downloading...' : 'Download PDF First'}
                </button>
              </div>
            ) : (
              <>
                <div className="bg-green-100 text-green-800 p-3 rounded-md mb-4 text-center">
                  PDF ready for sharing!
                </div>
                
                <div className="grid grid-cols-3 gap-4">
                  <button 
                    onClick={() => handleShare('whatsapp')}
                    className="flex flex-col items-center p-3 hover:bg-gray-100 rounded-lg"
                  >
                    <FaWhatsapp className="text-green-500 text-3xl mb-2" />
                    <span>WhatsApp</span>
                  </button>
                  <button 
                    onClick={() => handleShare('facebook')}
                    className="flex flex-col items-center p-3 hover:bg-gray-100 rounded-lg"
                  >
                    <FaFacebook className="text-blue-600 text-3xl mb-2" />
                    <span>Facebook</span>
                  </button>
                  <button 
                    onClick={() => handleShare('twitter')}
                    className="flex flex-col items-center p-3 hover:bg-gray-100 rounded-lg"
                  >
                    <FaTwitter className="text-blue-400 text-3xl mb-2" />
                    <span>Twitter</span>
                  </button>
                  <button 
                    onClick={() => handleShare('linkedin')}
                    className="flex flex-col items-center p-3 hover:bg-gray-100 rounded-lg"
                  >
                    <FaLinkedin className="text-blue-700 text-3xl mb-2" />
                    <span>LinkedIn</span>
                  </button>
                  <button 
                    onClick={() => handleShare('email')}
                    className="flex flex-col items-center p-3 hover:bg-gray-100 rounded-lg"
                  >
                    <FaEnvelope className="text-gray-600 text-3xl mb-2" />
                    <span>Email</span>
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ContractDocument;